import { each, find, orderBy } from 'lodash'
import { SortOrder } from '@/types'

export { default as DataTable } from './DataTable.vue'
export { default as DataTableHeader } from './DataTableHeader.vue'
export { default as DataTableRow } from './DataTableRow.vue'

export const HEADER_HEIGHT = 50
export const BODY_HEIGHT = 300
export const MIN_WIDTH = 30
export const SCROLL_WIDTH = 17

export interface ColItem {
  name: string
  headerText?: string
  align?: 'left' | 'center' | 'right'
  sortable?: boolean
  sortOrder?: SortOrder
  lineFeed?: boolean
}

export interface Col {
  width: number | string
  resizable?: boolean
  movable?: boolean
  required?: boolean
  items: ColItem[]
}

export interface ColInfo extends Col {
  index: number
  startX: number
  moving: boolean
  calcWidth: number
}

export interface HeaderItems {
  text: string
}

export interface Resize {
  doing: boolean
  cursor: {
    downX: number
    currentX: number
    upX: number
    differenceX: number
  }
  column: {
    left: {
      index: number
      originalIndex: number
      width: number
      newWidth: number
    }
    right: {
      index: number
      originalIndex: number
      width: number
      newWidth: number
    }
  }
}

export interface Move {
  doing: boolean
  ruler: number
  cursor: {
    downX: number
    currentX: number
    upX: number
    differenceX: number
    direction: 'left' | '' | 'right'
  }
  column: {
    initial: {
      startX: number
      endX: number
    }
    current: {
      startX: number
      endX: number
    }
    index: number
    originalIndex: number
  }
}

export interface SortColumn {
  name: string
  order: SortOrder
}

export const defaultSortColumn = (): SortColumn => ({
  name: '',
  order: ''
})

export function sortItems<T>(cols: Col[], items: T[]): T[] {
  const sortColItem = findSortColumnItem(cols)

  if (sortColItem === undefined || sortColItem.sortOrder === '') {
    return items
  }

  return orderBy(
    items,
    [sortColItem.name],
    [sortColItem.sortOrder as 'asc' | 'desc']
  )
}

export function setSortOrder(cols: Col[], sortColumn: SortColumn) {
  each(cols, (col: Col) => {
    each(col.items, (item: ColItem) => {
      if (item.name === sortColumn.name) {
        item.sortOrder = sortColumn.order
      } else {
        item.sortOrder = ''
      }
    })
  })
}

export function findSortColumnItem(cols: Col[]): ColItem | undefined {
  let result: ColItem | undefined
  each(cols, (col: Col) => {
    const item = find(col.items, (item: ColItem) => {
      return item.sortOrder !== undefined && item.sortOrder !== ''
    })
    if (item) {
      result = item
      return false
    }
  })

  return result
}
